import React, { useState, } from "react";
import { StyleSheet, TouchableOpacity, } from 'react-native';
import {ConnectionHis, ConnectionOrd} from '../~Utilities/Connection';
import { Text, View } from '../../../components/Themed';
import { FontInfo, Lookback } from "../~Utilities/Constants";
import { Data } from "../~Utilities/Data";
import QB from "../~Screens/QB";

export interface ILookBackBar
{
  oData           : Data;
  qbRef           : QB;
}

/*   ====================================================================   */

export default function LookBackBar(props : ILookBackBar) 
  {
    const [remountCount, setRemountCount] = useState(0);
    const updateUI = () => setRemountCount(remountCount + 1);

  /*   -------------------------------------------------------------------   */

  function SetLookback(oLB : Lookback)
  {
  //alert(props.lookback.Text);

  if (props.oData.lookback.LookbackType != oLB.LookbackType)
    {
    updateUI();

    //ConnectionOrd.SaveSettingsLB(props.token, oLB.LookbackType);

    ConnectionHis.Rq_GetBarsAndSubscribe(props.oData, oLB);
   
    }
  }

  /*   -------------------------------------------------------------------   */

  function GetFontBold(oLB : Lookback)
  {
    return (props.oData.lookback.LookbackType == oLB.LookbackType? 'bold' : 'normal');
  }

    /*   -------------------------------------------------------------------   */

  function GetFontColor(oLB : Lookback)
  {
    return (props.oData.lookback.LookbackType == oLB.LookbackType? 'slategray' : 'gainsboro');
  }

    /*   -------------------------------------------------------------------   */

  return(
    <View style={{zIndex:2, marginTop:0, marginLeft:0, alignSelf:'center', justifyContent:'center', width:350, height:20, backgroundColor:'transparent', flexDirection:'row'}}>
    {/* <AntDesign style={{width:40, marginBottom: 0, }} name="linechart" size={30} color='rgba(0,0,0,.7)' /> */}

    {/* <TouchableOpacity style={{marginTop:2, width:18, height:18, marginRight:4, borderRadius:9, borderWidth:1, borderColor:'rgba(112,128,144,.2)', alignItems:'center', justifyContent:'center'}}  
        onPress={()=>{props.qbRef?.oOrderRef?.ShowChartInfo()}}>
        <Text style={[FontInfo.appStyles.txt_normal, {fontSize:FontInfo.iFontSize-2, color:'slategrey'}]}>i</Text>
      </TouchableOpacity> */}

    <View style={{backgroundColor:'transparent', paddingLeft:0, flexDirection:'row', justifyContent:'center', }}>
    {
    ConnectionHis.oLookBacks.map((oLB) => 
          {
          return (
                  <TouchableOpacity key={oLB.LookbackType} style={[styles.container, {backgroundColor:'transparent', justifyContent:'center',}]} 
                    onPress={()=>{SetLookback(oLB)}}>
                    <Text style={[FontInfo.appStyles.txt_normal, styles.text, {marginTop:12+0, marginBottom:4, marginHorizontal:4, textAlign:'center', backgroundColor:'transparent', textAlignVertical:'center', minHeight:20, fontWeight:GetFontBold(oLB), color:GetFontColor(oLB)}]}>{oLB.Text}</Text>
                  </TouchableOpacity>
                 );
          })
    }

    {/* <TouchableOpacity style={[styles.container, {}]}
      onPress={()=>{SetLookback(Lookback.Year)}}>
      <Text style={{minWidth:38, fontSize:12, fontWeight:GetFontBold(Lookback.Year), color:GetFontColor(Lookback.Year)}}>1 Yr</Text>
    </TouchableOpacity>

    <TouchableOpacity style={[styles.container, {}]}
      onPress={()=>{SetLookback(Lookback.Month)}}>
      <Text style={[styles.text, {minWidth:38, fontWeight:GetFontBold(Lookback.Month), color:GetFontColor(Lookback.Month)}]}>3 Mo</Text>
    </TouchableOpacity>

    <TouchableOpacity style={[styles.container, {}]}
      onPress={()=>{SetLookback(Lookback.Week)}}>
      <Text style={[styles.text, {minWidth:38, fontWeight:GetFontBold(Lookback.Week), color:GetFontColor(Lookback.Week)}]}>1 Mo</Text>
    </TouchableOpacity>

    <TouchableOpacity style={[styles.container, {}]}
      onPress={()=>{SetLookback(Lookback.Day)}}>
      <Text style={[styles.text, {minWidth:40, fontWeight:GetFontBold(Lookback.Day), color:GetFontColor(Lookback.Day)}]}>1 Day</Text>
    </TouchableOpacity>

    <TouchableOpacity style={[styles.container, {}]}
      onPress={()=>{SetLookback(Lookback.Hour)}}>
      <Text style={[styles.text, {minWidth:38, fontWeight:GetFontBold(Lookback.Hour), color:GetFontColor(Lookback.Hour)}]}>1 Hr</Text>
    </TouchableOpacity>

    <TouchableOpacity style={[styles.container, {}]}
      onPress={()=>{SetLookback(Lookback.Min)}}>
      <Text style={[styles.text, {minWidth:40, fontWeight:GetFontBold(Lookback.Min), color:GetFontColor(Lookback.Min)}]}>1 Min</Text>
    </TouchableOpacity> */}
    </View>
    </View>
  ); 
}

const styles = StyleSheet.create({
  container: 
  {
    marginLeft:0,
    marginHorizontal:0,
    height:20, 
    borderRadius:4, 
    alignSelf:'center', 
    alignItems:'center', 
    alignContent:'center', 
    justifyContent:'center', 
    backgroundColor:'transparent', 
  },

  text: 
  {
    fontSize:12, 
    paddingHorizontal:2, 
  },
});